module.exports = __webpack_public_path__ + "static/media/circle11.0f66042e.svg";